import { HttpParams } from '@angular/common/http';

export class HttpParamsTags extends HttpParams {
  constructor(public param1: boolean) {
   super();
  }
}
